<!-- @format -->
<template>
	<el-tabs v-model="activeTab" stretch class="field-container-tabs">
		<el-tab-pane label="组件库" name="fields">
			<Fields :can-drag="canDrag" />
		</el-tab-pane>
		<el-tab-pane v-if="canTemplate" label="模版" name="template">
			<template-forms :template-list="templateList" @on-template-change="emits('on-template-change', $event)" />
		</el-tab-pane>
		<slot></slot>
	</el-tabs>
</template>

<script setup lang="ts">
	import { type TemplateType } from '../../types';
	import Fields from './fields/index.vue';
	import TemplateForms from './template/index.vue';

	interface Props {
		canDrag?: boolean;
		name?: string;
		canTemplate?: boolean;
		templateList?: TemplateType[];
	}

	const props = withDefaults(defineProps<Props>(), {
		canDrag: true,
	});

	const emits = defineEmits(['on-template-change']);

	const activeTab = ref('fields');

	// store唯一值
	provide('name', props.name);
</script>

<style scoped lang="scss">
	.field-container-tabs {
		height: 100%;

		:deep(.el-tabs__content) {
			height: calc(100% - 54px);
			overflow-y: scroll;
		}
	}
</style>
